import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { datePicker } from 'helpers';
import usePortalModal from 'hooks/usePortalModal';

const useFxPickupDateNoticePopup = () => {
  const { showPortalModalName } = usePortalModal();

  const dateUTC15122212 = datePicker.getDateUTC(22, 11, 2025);
  const isExpired15122212 = datePicker.getExpired(dateUTC15122212);
  const dateUTC23120101 = datePicker.getDateUTC(1, 12, 2025);
  const isExpired23120101 = datePicker.getExpired(dateUTC23120101);

  const isFxPickupDateNoticePopupExpired =
    isExpired15122212 && isExpired23120101;

  const getContentKey = () => {
    if (!isExpired15122212) {
      return 'popup_fx_pickup_date_notice_message_1';
    }
    if (!isExpired23120101) {
      return 'popup_fx_pickup_date_notice_message_2';
    }
    return '';
  };

  const showFxPickupDateNoticePopup = (action = () => {}) => {
    if (isFxPickupDateNoticePopupExpired) {
      action();
      return;
    }
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.FX_PICKUP_DATE_NOTICE_POPUP,
      content: getContentKey(),
      action,
    });
  };

  return { showFxPickupDateNoticePopup, isFxPickupDateNoticePopupExpired };
};

export default useFxPickupDateNoticePopup;
